export const ROOT_URI = '/agent/agentDocumentation';

export default {
  DIRECT_DEPOSIT_INFORMATION: `${ROOT_URI}/directDepositInformation`,
  ENROLL_MY_WAY: `${ROOT_URI}/enrollMyWay`,
  PRODUCER_COMPLIANCE_POLICY: `${ROOT_URI}/producerCompliancePolicy`,
};
